import { gql } from 'graphql-request'

export const SinglePersonQuery = gql`
  query SinglePerson(
    $slug: Person_slug_operator,
    $isPreview: Boolean! = false,
    $statuses: [Person__status_Input] = [published],
    $locale: LocaleInputType!
  ) {
    People(
        draft: $isPreview,
        locale: $locale,
        where: {
          AND: [
            { slug: $slug }
            { _status: { in: $statuses } }
          ]
        }
    ) {
      docs {
        title
        id
        hasDetailPage
        description
        yearOfBirth
        yearOfDeath
        nationalities {
          id
          municipality
          country
          isPlaceOfBirth
        }
        images ${fragmentMediaWithCoverQuery}
        recurrences {
          id
          dateStart
          dateEnd
          isOngoing
          type
          rooms {
            id
            title
            slug
          }
        }
        guestAppearances(sort: "-dateStart", limit: 100) {
          docs {
            id
            dateStart
            dateEnd
          }
        }
        programmes {
          docs {
            id
            title
            slug
            recurrences {
              id
              dateTimeStart
              dateTimeEnd
            }
            type {
              ... on ProgrammeType {
                slug
              }
            }
          }
        }
      }
      totalDocs
    }
  }
`
